import React from 'react';

export const TsuRunupsModal = {
  title: 'Number Of Runups',
  body: (
    <div>
      <p>
        The total number of runups link will display the runup locations associated with a particular tsunami event.
      </p>
    </div>
  ),
};
